/* eslint-disable max-classes-per-file */
import { APIHandler } from "../apiHandler";
import { getContext } from "../context";

// https://github.com/jupyter/notebook/blob/master/notebook/services/sessions/handlers.py
class SessionRootHandler extends APIHandler {
  private model: {} = {
    id: "9e44f59b-4b61-4402-98c9-725d67e359d9",
    path: "__notebook_source__.ipynb",
    name: "__notebook_source__.ipynb",
    type: "notebook",
    kernel: {
      id: "84fee83e-c04a-4135-a8a9-c22bb6070acf",
      name: "python3",
      last_activity: "2020-02-27T10:11:04.086856Z",
      execution_state: "dead",
      connections: 0,
    },
    notebook: {
      path: "__notebook_source__.ipynb",
      name: "__notebook_source__.ipynb",
    },
  };

  async get() {
    const proxyUrl = getContext().jupyterProxyUrl;
    if (proxyUrl) {
      await this.proxyRequest();
      return;
    }
    this.finish([]);
  }

  async post() {
    const proxyUrl = getContext().jupyterProxyUrl;
    if (proxyUrl) {
      await this.proxyRequest();
      return;
    }
    this.setStatus(201);
    this.finish(this.model);
  }
}

class SessionHandler extends APIHandler {
  async delete() {
    this.setStatus(204);
    this.finish(null);
    return Promise.resolve();
  }

  async patch() {
    const proxyUrl = getContext().jupyterProxyUrl;
    if (proxyUrl) {
      await this.proxyRequest();
      return;
    }
    this.setStatus(200);
    this.finish({});
  }
}

export const defaultHandlers: [string, typeof APIHandler][] = [
  ["/api/sessions/:session_id", SessionHandler],
  ["/api/sessions", SessionRootHandler],
];
